/**
 * API Configuration
 *
 * Centralized API URL configuration that adapts to different environments.
 * In development: uses local Express server (localhost:3001)
 * In production: uses Cloudflare Worker
 */

export const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001';

export const API_ENDPOINTS = {
  // Parallel AI
  tasksSuggest: `${API_BASE_URL}/api/tasks/suggest`,
  tasksRuns: `${API_BASE_URL}/api/tasks/runs`,
  tasksRunsById: (runId: string) => `${API_BASE_URL}/api/tasks/runs/${runId}`,
  tasksRunsResult: (runId: string) => `${API_BASE_URL}/api/tasks/runs/${runId}/result`,

  // OpenAI
  generateSchema: `${API_BASE_URL}/api/openai/generate-schema`,

  // Exa
  exaResearchTasks: `${API_BASE_URL}/api/exa/research/tasks`,
  exaResearchTaskById: (taskId: string) => `${API_BASE_URL}/api/exa/research/tasks/${taskId}`,

  // Anthropic
  anthropicEnrich: `${API_BASE_URL}/api/anthropic/enrich`,

  // Health check
  health: `${API_BASE_URL}/health`,
} as const;
